import { useSpring, animated, config } from "@react-spring/web";
import { useState } from "react";
import { IoMdPin } from "react-icons/io";
import logo from './SG_hex.svg'
import BYDLogo from './BYD-logo.png'
import Skeleton from 'react-loading-skeleton'
import { BsDisplayFill } from "react-icons/bs";

const ShopRow = ({ shopObj, onClick, style, loading, active }) => {
    const [isHovered, setIsHovered] = useState(false);

    const iconSpring = useSpring({
        config: config.wobbly,
        scale: isHovered || active ? 1.1 : 1
    })

    const borderSpring = useSpring({
        borderColor: isHovered || active ? "#ef4136" : "#003854"
    })

    if (loading) {
        return (
            <Skeleton
                className="h-16 mb-3"
            />
        )
    }

    return (
        <animated.div
            className={`border-l-8 bg-white flex flex-row rounded-md px-3 py-4 mb-4 ${isHovered ? "shadow-xl" : "shadow-md"} ${active ? "order-1" : "order-2"} cursor-pointer`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                ...borderSpring,
                ...style
            }}
            onClick={onClick}
        >
            <div
                className='flex items-center space-x-3'
            >
                <animated.div
                    className='w-9'
                    style={iconSpring}
                >
                    <img src={logo} />
                </animated.div>
                <div
                    className='leading-10'
                >
                    <div
                        className="flex flex-row"
                    >
                        <p
                            className='text-skgGray text-xs uppercase tracking-wide'
                        >
                            Skorstensgaard
                        </p>
                        {
                            !!shopObj.byd ? (
                                <div
                                    className="mx-3 h-[18px] w-[100px]"
                                >
                                    <img src={BYDLogo} alt="" srcset="" className="h-[14px] w-[75px] object-contain" />
                                </div>
                            ) : (
                                <div className="w-[118px]"></div>
                            )
                        }
                    </div>
                    <p
                        className='text-lg font-light'
                    >
                        {shopObj.name}
                    </p>
                    <p
                        className='text-skgGray text-xs uppercase tracking-wide md:hidden'
                    >
                        {shopObj.address}
                    </p>
                </div>
            </div>
            <div
                className='basis-full hidden md:flex flex-1 md:justify-center items-center font-light text-sm text-skgGray'
            >
                {shopObj.address}
            </div>
            {
                shopObj.distance && (
                    <div
                        className='flex flex-1 flex-row justify-end items-center space-x-1 md:space-x-4 text-red-500 text-xs font-extralight'
                    >
                        <span>{shopObj.distance.distance_text}</span>
                        <IoMdPin
                            size={20}
                        />
                    </div>
                )
            }
        </animated.div>
    )
}

export default ShopRow;